export default {
  allPayments: {},
  planData: {},
  paymentLink: {},
  payment: [],
  viewMembership: "",
};
